import React from 'react'
import moment from 'moment'

import { routes } from '../../../constants'
import { CellActions, CellStatus, ActionGroup } from './ContentPush.styles'

const tableDisplay = ({ t }) => {
    const elements = [
        {
            onlyOnMobile: true,
            field: 'name',
            label: t('Description'),
            props: null,
            transform: null,
            width: '100px',
        },
        {
            onlyOnMobile: true,
            field: 'status',
            label: t('Status'),
            transform: (s) => {
                if (s.id && s.name) return <CellStatus status={s.id}>{s.name}</CellStatus>
                return s
            },
            width: '100px',
        },
        {
            onlyOnMobile: true,
            field: 'date_start',
            label: t('Go Live'),
            transform: (gl) => gl && moment(new Date(gl)).fromNow(),
            width: '150px',
        },
        {
            onlyOnMobile: true,
            field: 'id',
            label: null,
            transform: (id) => id && <CellActions to={`${routes['CONTENT_PUSH_FORM:EDIT']}${id}`}>{t('Edit')}</CellActions>,
            width: null,
        },
        {
            field: 'name',
            label: t('Description'),
            props: null,
            transform: null,
            width: '170px',
        },
        {
            field: 'level_required',
            label: t('Level'),
            props: null,
            transform: (l) => l.name,
            width: '130px',
        },
        {
            field: 'status',
            label: t('Status'),
            transform: (s) => {
                if (s.id && s.name) return <CellStatus status={s.id}>{s.name}</CellStatus>
                return s
            },
            width: '110px',
        },
        {
            field: 'date_start',
            label: t('Go Live'),
            transform: (gl) => gl && moment(new Date(gl)).fromNow(),
            width: '150px',
        },
        {
            field: 'id',
            label: null,
            transform: (id) =>
                id && (
                    <ActionGroup>
                        <CellActions to={`${routes['CONTENT_PUSH_FORM:EDIT']}${id}`}>{t('Edit')}</CellActions>
                    </ActionGroup>
                ),
            width: null,
        },
    ]

    return elements
}

export default tableDisplay
